var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7502 20.6886L16.0861 15.0246C17.4471 13.3906 18.1258 11.2948 17.981 9.17314C17.8362 7.05151 16.8789 5.06738 15.3085 3.63353C13.738 2.19967 11.6752 1.42648 9.54918 1.47479C7.42316 1.5231 5.39761 2.3892 3.89389 3.89292C2.39018 5.39663 1.52408 7.42218 1.47577 9.54821C1.42746 11.6742 2.20065 13.737 3.63451 15.3075C5.06836 16.878 7.05248 17.8352 9.17412 17.98C11.2958 18.1249 13.3915 17.4462 15.0255 16.0851L20.6896 21.7492L21.7502 20.6886ZM3.00018 9.7492C3.00018 8.41418 3.39606 7.10913 4.13776 5.9991C4.87946 4.88907 5.93366 4.02391 7.16706 3.51301C8.40047 3.00212 9.75767 2.86845 11.067 3.1289C12.3764 3.38935 13.5791 4.03223 14.5231 4.97623C15.4672 5.92023 16.11 7.12297 16.3705 8.43234C16.6309 9.74171 16.4973 11.0989 15.9864 12.3323C15.4755 13.5657 14.6103 14.6199 13.5003 15.3616C12.3902 16.1033 11.0852 16.4992 9.75018 16.4992C7.96058 16.4972 6.24484 15.7854 4.9794 14.52C3.71396 13.2545 3.00216 11.5388 3.00018 9.7492Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.ea6dafab02d15ca139032d51944cc840.svg";
export { ForwardRef as ReactComponent };